import "core-js/features/url-search-params";

export function initTokenFragmentRedirect() {
  if (window.location.hash) {
    const fragment = decodeURIComponent(window.location.hash).substring(1);
    if (fragment.startsWith("__token:")) {
      const tokenParam = fragment.match(/[a-z_]+\[token\]\=[a-z0-9]+/i);
      if (tokenParam?.[0]) {
        const u = new URL(String(window.location));
        u.hash = "";
        const p = tokenParam[0].split("=");
        u.searchParams.set(p[0], p[1]);
        window.location.href = String(u);
      }
    }
  }
}
